<script setup lang="ts">

import type {InputField} from "~/constants/types/serviceInputs";

const props = defineProps<{
  field: InputField
}>();

if (!props.field.option){
  props.field.option = props.field.options.find((option)=>option.value === props.field.default_value)?.value;
}
const handleSelect = (option:any) => {
  props.field.option=option;
  props.field.default_value = option;
};

watch(useStoreSelectedServiceId(),()=>{
  props.field.option = props.field.options.find((option)=>option.value === props.field.default_value)?.value ;
})
const selected = computed(() => props.field.default_value);

function validate(event: any) {
  if (event.target.value < props.field.validation_rules?.min??0) {
    props.field.default_value= props.field.validation_rules?.min??0
  }
  if (event.target.value >= props.field.validation_rules?.max) {
    props.field.default_value = props.field.validation_rules?.max
  }
}


</script>

<template>
  <div class="flex flex-col rounded-xl gap-3 justify-between">
    <div class="flex flex-row gap-4 justify-between">
      <div>
        <p class="order-service-form-text">{{ $t('order.body.services.quadrature') }}</p>
        <input
            v-model="field.default_value"
            id="quadrature"
            class="mt-2 w-full appearance-none border rounded-[6px] border-gray-300 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="number"
            placeholder="1"
            @blur="validate"
        >
      </div>
    </div>
    <div class="flex flex-row gap-2">
      <p v-for="option in field.options" @click="handleSelect(option.value)"
           class="text-sm appearance-none border rounded-full px-3 focus:outline-none focus:shadow-outline cursor-pointer p-1 flex justify-center "
           :class="selected==option.value? 'bg-primary-green bg-opacity-5 border-primary-green' : 'border-neutral-light-gray'"
      >
        {{option.option}}
      </p>
    </div>
  </div>

</template>

<style scoped>

</style>